export default {
  text: '¡Realizaste un pedido hace menos de 15 minutos! Confirma si deseas continuar con este nuevo pedido o gestionar el existente.',
  buttons: {
    see_existing_order: 'Ver pedido existente',
    proceed_new_order: 'Continuar nuevo pedido',
  },
};
